/**
 * Overlay Modifier Utilities
 * 
 * Transform modifiers for drag overlays to adjust for sidebar offset.
 * Used with dnd-kit's DragOverlay modifiers prop.
 */

/**
 * Get the sidebar + gutter offset from CSS custom properties
 * @returns {number} Offset in pixels from the left edge to main content
 */
const getSidebarOffset = () => {
  const styles = getComputedStyle(document.documentElement);
  const width = parseInt(styles.getPropertyValue('--sidebar-width') || '220', 10);
  const gap = parseInt(styles.getPropertyValue('--sidebar-gap') || '0', 10);
  return width + gap;
};

/**
 * Modifier for column overlay - adjusts for sidebar offset
 * @param {{ transform: { x: number, y: number, scaleX: number, scaleY: number } }} args
 * @returns {{ x: number, y: number, scaleX: number, scaleY: number }}
 */
export const adjustColumnOverlay = ({ transform }) => {
  const sidebarOffset = getSidebarOffset();
  
  return {
    ...transform,
    x: transform.x - sidebarOffset,
    y: transform.y,
  };
};

/**
 * Modifier for card overlay - adjusts for sidebar offset
 * @param {{ transform: { x: number, y: number, scaleX: number, scaleY: number } }} args
 * @returns {{ x: number, y: number, scaleX: number, scaleY: number }}
 */
export const adjustCardForSidebar = ({ transform }) => {
  const sidebarOffset = getSidebarOffset();
  
  return {
    ...transform,
    // Subtract sidebar + gutter so the card follows from its grab point
    x: transform.x - sidebarOffset,
    y: transform.y,
  };
};

